// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select-container {
  position: relative;
  width: 100%;
  max-width: 375px;
}

.multi-select-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 38px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.multi-select-input:hover {
  border-color: #aaa;
}

.multi-select-input.open {
  border-color: #4a90e2;
  box-shadow: 0 0 0 1px #4a90e2;
}

.selected-options {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  flex: 1;
}

.selected-option-badge {
  display: inline-flex;
  align-items: center;
  background-color: #e8f0fe;
  color: #1a73e8;
  border-radius: 16px;
  padding: 2px 8px;
  margin: 2px;
  font-size: 14px;
}

.remove-option {
  background: none;
  border: none;
  color: #5f6368;
  margin-left: 4px;
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
}

.remove-option:hover {
  color: #d93025;
}

.placeholder {
  color: #757575;
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 10px;
  color: #5f6368;
  margin-left: 8px;
}

.options-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 300px;
  margin-top: 5px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.search-container {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.search-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.options-list {
  overflow-y: auto;
  max-height: 240px;
}

.option {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
}

.option:hover {
  background-color: #f5f5f5;
}

.option.selected {
  background-color: #f0f7ff;
}

.option input[type=checkbox] {
  margin-right: 8px;
}

.no-options {
  padding: 12px;
  text-align: center;
  color: #757575;
}`, "",{"version":3,"sources":["webpack://./src/components/MultiSelect/MultiSelect.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;AACJ;;AAEE;EACE,kBAAA;AACJ;;AAEE;EACE,qBAAA;EACA,6BAAA;AACJ;;AAEE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;AACJ;;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AACJ;;AAEE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAEE;EACE,cAAA;AACJ;;AAEE;EACE,cAAA;EACA,eAAA;AACJ;;AAEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;AACJ;;AAEE;EACE,YAAA;EACA,6BAAA;AACJ;;AAEE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEE;EACE,gBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE,iBAAA;AACJ;;AAEE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AACJ","sourcesContent":[".multi-select-container {\n    position: relative;\n    width: 100%;\n    max-width: 375px;\n  }\n  \n  .multi-select-input {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 38px;\n    padding: 6px 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: white;\n    cursor: pointer;\n    transition: border-color 0.2s;\n  }\n  \n  .multi-select-input:hover {\n    border-color: #aaa;\n  }\n  \n  .multi-select-input.open {\n    border-color: #4a90e2;\n    box-shadow: 0 0 0 1px #4a90e2;\n  }\n  \n  .selected-options {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    flex: 1;\n  }\n  \n  .selected-option-badge {\n    display: inline-flex;\n    align-items: center;\n    background-color: #e8f0fe;\n    color: #1a73e8;\n    border-radius: 16px;\n    padding: 2px 8px;\n    margin: 2px;\n    font-size: 14px;\n  }\n  \n  .remove-option {\n    background: none;\n    border: none;\n    color: #5f6368;\n    margin-left: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 0 4px;\n  }\n  \n  .remove-option:hover {\n    color: #d93025;\n  }\n  \n  .placeholder {\n    color: #757575;\n    font-size: 14px;\n  }\n  \n  .dropdown-arrow {\n    font-size: 10px;\n    color: #5f6368;\n    margin-left: 8px;\n  }\n  \n  .options-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    max-height: 300px;\n    margin-top: 5px;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n  }\n  \n  .search-container {\n    padding: 8px;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .search-input {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  .options-list {\n    overflow-y: auto;\n    max-height: 240px;\n  }\n  \n  .option {\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    cursor: pointer;\n  }\n  \n  .option:hover {\n    background-color: #f5f5f5;\n  }\n  \n  .option.selected {\n    background-color: #f0f7ff;\n  }\n  \n  .option input[type=\"checkbox\"] {\n    margin-right: 8px;\n  }\n  \n  .no-options {\n    padding: 12px;\n    text-align: center;\n    color: #757575;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
